// React mirror of the `uitest` Slim view helper (app/lib/ui_testing.rb).
// Emits a `data-uit` test hook ONLY in development/test builds; webpack inlines
// process.env.NODE_ENV and dead-code-eliminates the attribute from production and
// staging bundles (both build with NODE_ENV=production), so it never ships to users.
// Allow-list (not deny-list) so any unexpected build env fails safe = stripped.
// Spread into an element: <input {...uitest("port_filter")} />
const TEST_HOOK_ENVS = ["development", "test"]

export const uitest = (name?: string): { "data-uit"?: string } =>
  name && TEST_HOOK_ENVS.includes(process.env.NODE_ENV) ? { "data-uit": name } : {}
